class BannerHome {

    constructor() {

        var that = this;

        that.cpt_reinit = 0;
        that.sliders = [{
            /**
             * SLIDER team
             */
            slider: '.flex-banner-home .wrapper-slide',
            args: {
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<a href="#" class="slick-prev arrow-white"><img src="/wp-content/themes/vahumana/assets/dist/images/icon-slider-arrow-left.png" alt=""></a>',
                nextArrow: '<a href="#" class="slick-next arrow-white"><img src="/wp-content/themes/vahumana/assets/dist/images/icon-slider-arrow-right.png" alt=""></a>',
                fade: true,
                asNavFor: '.wrapper-nav-slide',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                        }
                    }
                ]
            }
        }, {
            slider: '.flex-banner-home .wrapper-nav-slide',
            args: {
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.wrapper-slide',
                arrows: false,
                centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            }
        }];
        that.init();

        jQuery(document).ajaxComplete(function () {
            that.reinit();
        });
    }

    init()
    {
        jQuery.each(this.sliders, function (i, val) {
            var $slider = jQuery( val.slider );

            if ( $slider.length ) {
                $slider.slick( val.args );
            }
        });
    }
    reinit()
    {
        var that = this;
        that.cpt_reinit++;
        var cpt = that.cpt_reinit;

        setTimeout(function () {
            if ( cpt === that.cpt_reinit ) {
                jQuery.each(that.sliders, function (i, val) {
                    var $slider = jQuery( val.slider );

                    if ( $slider.length && ! $slider.hasClass('slick-initialized') ) {
                        $slider.slick( val.args );
                    }
                });
            }
        }, 300);
    }
}

jQuery(document).ready(function ($) { new BannerHome() });
